// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#fff","subMenuActiveText":"#f4f4f5","menuBg":"#293e73","menuHover":"#263445","sideBarWidth":"210px"};